import { useLingui } from "@lingui/react/macro";
import React from "react";
import {
  ExcursionAccessibilityLevel,
  IconName
} from "@silversea-ssc/ui-components-react";
import { useExcursionsMicroContent } from "src/page-components/cruise/ExcursionsMicroContentProvider";

interface ExcursionAccessibilityLevelProps {
  level: string;
  showDescription?: boolean;
}

const ContentExcursionAccessibilityLevel: React.FC<
  React.PropsWithChildren<ExcursionAccessibilityLevelProps>
> = ({ level, showDescription = false }) => {
  const { t } = useLingui();
  const { accessibilityLevels = [] } = useExcursionsMicroContent();
  const { icon, label, content } =
    accessibilityLevels.find((x) => x?.code == level) || {};

  return (
    <ExcursionAccessibilityLevel
      icon={icon as IconName}
      code={level}
      label={label?.localized}
      description={content?.localized}
      title={t`Accessibility`}
      showDescription={showDescription}
    />
  );
};

export default ContentExcursionAccessibilityLevel;
